import { getUserPending, getUserSuccess, getUserFail } from "./userSlice";
import { fetchUser } from "../../../api/userApi";

export const getUserProfile = () => async(dispatch) => {
    try {
         //call the api
        dispatch(getUserPending());
        const result = await fetchUser();
       // const userData=JSON.parse(result.user);
//console.log('userData '+result);
//console.log('getuserpending '+result.user[0].firstName);
/* console.log('getuserpending user '+result.user[0].firstName);
console.log('getuserpending fname '+result.lastName);
console.log('getuserpending lname '+result.user.lastName); */
//console.log('check user profile out if');
        if(result.user[0] && result.user[0].id){
        //console.log('check user profile');
            return dispatch(getUserSuccess(result.user[0]));
        }
        dispatch(getUserFail("User is not found"));

       
    } catch (error) {
        dispatch(getUserFail(error));

    }
}